import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO13485InternalAuditor = () => {
  const standard = getStandardBySlug('iso-13485');
  const content = getInternalAuditorContent('iso-13485');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
